module.exports = __webpack_public_path__ + "img/Joinpoint 2018 rankings.e97c868e.png";